import { initMDCRipple } from './ripple';

/**
 * Init Masthead.
 *
 * @link https://github.com/material-components/material-components-web/tree/v0.28.0/master/packages/mdc-toolbar
 *
 * @since 0.0.1
 * @return {void} 
 */
export function initMasthead() {

	function getScrollTop() {
		const doc = document.documentElement;
		const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
		return parseFloat(scrollTop, 10);
	}

	function getDocHeight() {
		const body = document.body;
		const html = document.documentElement;
		const height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
		return parseFloat(height, 10);
	}

	function getViewportHeight() {
		const body = document.getElementsByTagName('body')[0];
		const height = window.innerHeight || document.documentElement.clientHeight || body.clientHeight;
		return parseFloat(height, 10);
	}

	const masthead = document.querySelector('#masthead');
	const fab = document.querySelector('#fab');

	document.addEventListener('scroll', (e) => {
		const scrollTop = getScrollTop();
		const docHeight = getDocHeight();
		const viewportHeight = getViewportHeight();
		// if we are scrolling
		if (scrollTop > 0) {
			// add the scroll class to masthead
			if (masthead && ! masthead.classList.contains('pbsm-masthead--scroll')) {
				masthead.classList.add('pbsm-masthead--scroll');
			}
			// if we are at the bottom of the document (-100px for buffer)...
			if (scrollTop >= ((docHeight - viewportHeight) - 100)) {
				// add the exited class to the fab.
				if (fab && ! fab.classList.contains('mdc-fab--exited')) {
					fab.classList.add('mdc-fab--exited');
				}
			} else {
				// else if we are not at the bottom of the document,
				// remove the exited class from the fab.
				if (fab && fab.classList.contains('mdc-fab--exited')) {
					fab.classList.remove('mdc-fab--exited');
					initMDCRipple(fab, 500);
				}
			}
		} else {
			// else if we are at the top of the document, 
			// remove the scroll class from the masthead.
			if (masthead && masthead.classList.contains('pbsm-masthead--scroll')) {
				masthead.classList.remove('pbsm-masthead--scroll');
				initMDCRipple(fab, 500);
			}
			// add the exited class to the fab.
			if (fab && ! fab.classList.contains('mdc-fab--exited')) {
				fab.classList.add('mdc-fab--exited');
			}
		}
	});
}